export const ACTION_RESET = 'FETCH_BRANDSDATALIST_RESET';
export const ACTION_REQUEST = 'FETCH_BRANDSDATALIST_REQUEST';
export const ACTION_SUCCESS = 'FETCH_BRANDSDATALIST_SUCCESS';
export const ACTION_ERROR = 'FETCH_BRANDSDATALIST_ERROR';
